import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router'
import { z } from 'zod'

import { loadUserCrumb, useLateUserCrumb } from '@/app/user-crumb'
import { UserDetail } from '@/features/users/user-detail'
import { USER_TABS, type UserTabId } from '@/features/users/user-tabs'

const TAB_IDS = USER_TABS.map(tab => tab.id) as [UserTabId, ...UserTabId[]]

const searchSchema = z.object({
    tab: z.enum(TAB_IDS).catch('profile'),
    /** A transaction or card id to centre the timeline graph on. */
    focus: z.string().optional().catch(undefined)
})

export interface UserDetailSearch {
    tab: UserTabId
    focus?: string
}

export const Route = createFileRoute('/_app/users/$userId')({
    // Tagged with `SearchSchemaInput` so `<Link to="/users/$userId">` does not have to
    // spell out a tab it does not care about, while `useSearch()` still reads a
    // fully-defaulted object.
    validateSearch: (search: { tab?: unknown; focus?: unknown } & SearchSchemaInput): UserDetailSearch =>
        searchSchema.parse(search ?? {}),
    loader: loadUserCrumb,
    component: UserRoute,
    staticData: { crumb: 'User' }
})

function UserRoute() {
    useLateUserCrumb(Route.id, Route.useParams().userId, Route.useLoaderData().crumb)
    return <UserDetail />
}
